export default class AsyncUtils {
  static async wait(timeout: number): Promise<void> {
    return new Promise((res, rej) => {
      setTimeout(() => res(null), timeout);
    });
  }
}
